import { defineIntegration, safeSetSpanJSONAttributes, SEMANTIC_ATTRIBUTE_SENTRY_OP } from '@sentry/core/browser';
import { getHttpRequestData, WINDOW } from '../helpers';
import { URL_FULL } from '@sentry/conventions/attributes';

/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */
export const httpContextIntegration = defineIntegration(() => {
  return {
    name: 'HttpContext' as const,
    preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
        return;
      }

      const reqData = getHttpRequestData();
      const headers = {
        ...reqData.headers,
        ...event.request?.headers,
      };

      event.request = {
        ...reqData,
        ...event.request,
        headers,
      };
    },
    processSegmentSpan(span) {
      const spanOp = span.attributes?.[SEMANTIC_ATTRIBUTE_SENTRY_OP];

      // if none of the information we want exists, don't bother
      if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
        return;
      }

      const reqData = getHttpRequestData();

      safeSetSpanJSONAttributes(span, {
        // Coerce empty string to undefined so the helper's nullish check drops it,
        // rather than writing an empty `url.full` attribute onto the span.
        [URL_FULL]: spanOp !== 'http.client' ? reqData.url : undefined,
        'http.request.header.user_agent': reqData.headers['User-Agent'],
        'http.request.header.referer': reqData.headers['Referer'],
      });
    },
  };
});
